var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5"},[_c('WebsiteIntro'),_c('MobileBanner'),_c('CompaniesWeWorkWith'),_c('FrequentlyAskQuestions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }